import { DashboardType, useSystemClassifierItemsBy } from '@atlas-frontend/sdk';
import { useMemo } from 'react';

export function useDashboardType(dashboardTypeId: number): DashboardType {
  const classifiers = useSystemClassifierItemsBy(['VISUAL_DASHBOARD_TYPE']);

  return useMemo(() => {
    const type =
      classifiers['VISUAL_DASHBOARD_TYPE'].get(dashboardTypeId)?.code;
    if (!type) {
      return DashboardType.CROSSTABLE;
    }

    return type as DashboardType;
  }, [classifiers, dashboardTypeId]);
}
